import React from 'react';

export const ResultActionBar = ({
  totalTests = 0,
  selectedCount = 0,
  onSelectAll,
  onDeselectAll,
  onSaveDraft,
  onFinalizeApprove,
  onOpenRevise,
  onOpenAudit,
  onOpenHistory,
  onPrintReport,
  submitting = false,
  hasApprovedSelected = false,
  hasDraftOrPendingSelected = false,
  onSaveAndNext = null,
}) => {
  return (
    <div className="path-sticky-action-bar">
      <div className="path-action-bar-inner">
        {/* Left: Selection Counter & Quick Selection */}
        <div className="path-selection-summary">
          <div className="counter-pill">
            <span className="count-num">{selectedCount}</span> of {totalTests} Tests Selected
          </div>
          <div className="selection-btns">
            <button
              type="button"
              className="path-btn-link"
              onClick={onSelectAll}
              disabled={submitting}
            >
              Select All
            </button>
            <span className="sep">•</span>
            <button
              type="button"
              className="path-btn-link"
              onClick={onDeselectAll}
              disabled={submitting || selectedCount === 0}
            >
              Clear Selection
            </button>
          </div>
        </div>

        {/* Right: Actions */}
        <div className="path-action-buttons-group">
          {/* Secondary Actions */}
          <button
            type="button"
            className="path-btn path-btn-secondary"
            onClick={onOpenHistory}
            title="View historical lab results for this patient"
          >
            📜 History / Previous
          </button>

          <button
            type="button"
            className="path-btn path-btn-secondary"
            onClick={onOpenAudit}
            disabled={selectedCount === 0}
            title="View parameter change delta audit trail"
          >
            🔍 Audit Trail
          </button>

          <button
            type="button"
            className="path-btn path-btn-secondary"
            onClick={onPrintReport}
            title="Preview or print verified report"
          >
            🖨️ Print Report
          </button>

          {/* Revise Button (active if an approved test is selected) */}
          {hasApprovedSelected && (
            <button
              type="button"
              className="path-btn path-btn-warning"
              onClick={onOpenRevise}
              disabled={submitting || selectedCount === 0}
              title="Revise approved test report with mandatory reason"
            >
              ✏️ Revise Report
            </button>
          )}

          {/* Save Draft */}
          <button
            type="button"
            className="path-btn path-btn-info"
            onClick={onSaveDraft}
            disabled={submitting || selectedCount === 0 || !hasDraftOrPendingSelected}
            title="Save draft for selected tests (unselected tests remain untouched)"
          >
            {submitting ? 'Saving...' : '💾 Save Draft'}
          </button>

          {/* Save & Next */}
          {onSaveAndNext && (
            <button
              type="button"
              className="path-btn path-btn-primary"
              onClick={onSaveAndNext}
              disabled={submitting || selectedCount === 0 || !hasDraftOrPendingSelected}
              title="Save draft for active test and move to next test"
            >
              {submitting ? 'Saving...' : '💾 Save & Next ⏭'}
            </button>
          )}

          {/* Save & Approve / Finalize */}
          <button
            type="button"
            className="path-btn path-btn-success"
            onClick={onFinalizeApprove}
            disabled={submitting || selectedCount === 0 || !hasDraftOrPendingSelected}
            title="Approve and finalize verified results for selected tests"
          >
            {submitting ? 'Processing...' : '✅ Save & Approve'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultActionBar;
